ready = ->
  $("body").on "click", ".btn-clear-filter-user-activities", (e) ->
    e.preventDefault()
    $(".date-range-activities").val(" ")
    form = $("#user_activities_filter_form")
    form.find("input[type='submit']").click()

$(document).on 'turbolinks:load', ready